import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../../Pages/Home";
import Login from "../../Pages/Login";
import Trending from "../../Pages/Trending";
import Signup from "../../Pages/Signup";
import UserProfil from "../../Pages/UserProfil";
import AdminUsers from "../../Pages/AdminUsers";
import ForgotPassword from "../../Pages/ForgotPassword";
import NewPassword from "../../Pages/NewPassword";
import Knowledge from "../../Pages/Knowledge";
import KnowledgeInfo from "../../Pages/KnowledgeInfo";
import Post from "../../Pages/Post";
import AdminKnowledge from "../../Pages/AdminKnowledge";
import AdminKnowledgeAssign from "../../Pages/AdminKnowledgeAssigne";
import AdminKnowledgeTermine from "../../Pages/AdminKnowledgeTermine";
import AdminKnowledgeAnnule from "../../Pages/AdminKnowledgeAnnule";
import Convertisseur from "../../Pages/Convertisseur";
import AdminOutilsExt from "../../Pages/AdminOutilsExt";
import AdminBoiteAOutils from "../../Pages/AdminBoiteAOutils";
import AdminQuiContacter from "../../Pages/AdminQuiContacter";
import AdminDashBoard from "../Admin/AdminDashBoard";
import AdminFormations from "../../Pages/AdminFormations";
import AdminFormationGenerate from "../../Pages/AdminFormationGenerate";
import AdminFormationBuilder from "../../Pages/AdminFormationBuilder";
import AdminFormationResults from "../../Pages/AdminFormationResults";
import AdminFormationStats from "../../Pages/AdminFormationStats";
import Formations from "../../Pages/Formations";
import FormationDetail from "../../Pages/FormationDetail";
import FormationLesson from "../../Pages/FormationLesson";
import FormationQuiz from "../../Pages/FormationQuiz";
import AdminChatbotQA from "../../Pages/AdminChatBot";

const index = ({ socket }) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home socket={socket} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/reset/:token" element={<NewPassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/userprofil/:id"
          element={<UserProfil socket={socket} />}
        />
        <Route path="/trending" element={<Trending />} />
        <Route path="/adminUsers" element={<AdminUsers />} />
        <Route path="/dashboard" element={<AdminDashBoard />} />
        <Route path="/nosoutilsExt" element={<AdminOutilsExt />} />
        <Route
          path="/boiteaoutils"
          element={<AdminBoiteAOutils socket={socket} />}
        />
        <Route
          path="/chatbotadmin"
          element={<AdminChatbotQA socket={socket} />}
        />
        <Route path="/quicontacter" element={<AdminQuiContacter />} />
        <Route path="/tutoriels" element={<Knowledge socket={socket} />} />
        <Route
          path="/tutoriels/:id"
          element={<KnowledgeInfo socket={socket} />}
        />
        <Route path="/requestKnowledge/" element={<AdminKnowledge />} />
        <Route path="/assignee" element={<AdminKnowledgeAssign />} />
        <Route path="/requestTermine" element={<AdminKnowledgeTermine />} />
        <Route path="/requestAnnule" element={<AdminKnowledgeAnnule />} />
        <Route path="/post/:id" element={<Post socket={socket} />} />
        <Route
          path="/convertisseur"
          element={<Convertisseur socket={socket} />}
        />
        <Route path="/admin/formations" element={<AdminFormations />} />
        <Route path="/admin/formations/statistiques" element={<AdminFormationStats />} />
        <Route path="/admin/formations/nouvelle" element={<AdminFormationGenerate />} />
        <Route path="/admin/formations/:id/edition" element={<AdminFormationBuilder />} />
        <Route path="/admin/formations/:id/resultats" element={<AdminFormationResults />} />
        <Route path="/formations" element={<Formations socket={socket} />} />
        <Route path="/formations/:id" element={<FormationDetail socket={socket} />} />
        <Route path="/formations/:id/apprendre/:lessonId" element={<FormationLesson socket={socket} />} />
        <Route path="/formations/:id/quizz/:quizId" element={<FormationQuiz socket={socket} />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};

export default index;
